import { TabSwitch, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';

import { CustomerDetailTypes } from '../..';
import { CustomerDetailStackParamList } from '../../../../routes/types';
import { useCustomerDetailsActions } from '../../../../store/customerDetail/actions';

import { financialDetailsInitialTab, financialDetailsTabs } from './constants';
import { FinancialDetailsProvider } from './context';

export const FinancialDetails: React.FC<CustomerDetailTypes.Props> = () => {
  const { setCustomersAssetsDateSelected } = useCustomerDetailsActions();
  const routeParams = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const initialTab = routeParams.params?.financialDetailsInitialTab || financialDetailsInitialTab;

  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  const isMobileOrTablet = useBreakpointValue({
    base: true,
    md: false,
  });

  const [selectedTab, setSelectedTab] = useState(initialTab);

  useEffect(() => {
    setCustomersAssetsDateSelected(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FinancialDetailsProvider>
      <VStack flex={1}>
        <TabSwitch
          widthFull={isMobileOrTablet}
          testId="tab-switch"
          tabs={financialDetailsTabs}
          selectedTab={selectedTab}
          onTabPress={setSelectedTab}
          isMobile={isMobile}
          isLoading={false}
          buttonStyleProps={{ desktop: { width: undefined, px: 'inline.xxxs' } }}
        />
      </VStack>
    </FinancialDetailsProvider>
  );
};
